/* eslint react-hooks/rules-of-hooks: "error", react-hooks/exhaustive-deps: "error" */
import React, { createContext, useContext, useMemo } from "react";
import { mergePromotion } from "./helpers";
import { PromotionProviderProps, SpecialEvents } from "./types";

export const PromotionContext = createContext<SpecialEvents>(null);
const { Provider } = PromotionContext;

export const usePromotion = () => {
  const promotion = useContext(PromotionContext);
  return promotion === null ? {} : promotion;
};

export const PromotionProvider: React.FC<PromotionProviderProps> = ({ value, children }) => {
  const promotion = useMemo(() => mergePromotion(value), [value]);
  return <Provider value={promotion}>{children}</Provider>;
};
